import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AccordionModule } from 'ngx-bootstrap/accordion';

// Import your components (standalone or via NgModules)
import { HomeComponent } from './pages/home/home.component';
import { SigninComponent } from './pages/signin/signin.component';
import { ForeignCoursesComponent } from './foreignCourse/foreign-courses.component';
import { ForeignCollegeFeesComponent } from './foreignFees/foreign-college-fees.component';
import { ForeignCollegeImagesComponent } from './foreignImages/foreign-college-images.component';
import { ForeignOrderCollegeComponent } from './foreignOrder/foreign-order-college.component';
import { ForeignCollegeVideosComponent } from './foreignVideos/foreign-college-videos.component';
import { OrderCollegeComponent } from './ordercollege/order-college.component';
import { AgGridModule } from 'ag-grid-angular';

// ...add other standalone pages here

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule,

    // BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    NgxSpinnerModule,
    NgbModule,
    ToastrModule,
    AccordionModule,

    // Standalone Pages
    HomeComponent,
    SigninComponent,
    ForeignCoursesComponent,
    ForeignCollegeFeesComponent,
    ForeignCollegeImagesComponent,
    ForeignOrderCollegeComponent,

    AgGridModule, // <-- import AgGridModule directly (no withComponents)
    // ForeignCollegeVideosComponent,
    OrderCollegeComponent,
    // ...other pages/components
  ],
})
export class AppComponent {
  loading = false; // spinner flag
}
